import React from "react";

const NewParentSite = ({ onCancel, onSubmit }) => {
	const nameRef = React.createRef();
	const emailRef = React.createRef();
	const telNoRef = React.createRef();

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				const name = nameRef.current.value;
				const email = emailRef.current.value;
				const tel = telNoRef.current.value;
				onSubmit({ name, email, tel });
				nameRef.current.value = "";
				emailRef.current.value = "";
				telNoRef.current.value = "";
			}}
		>
			<div className="form-body">
				<div className="form-group">
					<label className="control-label">
						Name
						<span className="required"> * </span>
					</label>
					<input
						type="text"
						name="name"
						ref={nameRef}
						data-required="1"
						placeholder="enter parent site name"
						className="form-control input-height"
					/>
				</div>

				<div className="form-group">
					<label className="control-label">
						Email Address
						<span className="required"> * </span>
					</label>
					<input
						type="email"
						ref={emailRef}
						className="form-control input-height"
						name="email"
						placeholder="Email Address"
					/>
				</div>

				<div className="form-group">
					<label className="control-label">
						Mobile No.
						<span className="required"> * </span>
					</label>
					<input
						name="tel_number"
						type="text"
						ref={telNoRef}
						placeholder="mobile number"
						className="form-control input-height"
					/>
				</div>
				<div className="text-center">
					<button
						type="button"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-default margin-right-10"
						onClick={onCancel}
					>
						<i className="material-icons text-danger">cancel</i> Cancel
					</button>
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
					>
						Submit <i className="material-icons">arrow_forward</i>
					</button>
				</div>
			</div>
		</form>
	);
};

export default NewParentSite;
